import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import FormDrawerWrapper from '../../../features/components/FormDrawerWrapper'
import PartnerbrainOptimisationsForm from './PartnerbrainOptimisationsForm'

import useManageDrawer from '../../../hooks/formHooks/useManageDrawer'

import {
  getRightSuggestedChanges,
  clearRightSuggestedChanges,
  getPartnerbrainHistory,
  clearPartnerbrainHistory
} from '../../../modules/actions/rights'
import {
  partnerbrainHistoryWasLoadedSelector,
  rightSelector,
  rightSuggestedChangesWasLoadedSelector
} from '../../../modules/selectors/rights'

import { PARTNERBRAIN_OPTIMISATIONS } from '../../../constants/forms'

const PartnerbrainOptimisations = () => {
  const dispatch = useDispatch()

  const right = useSelector(rightSelector)
  const rightSuggestedChangeWasLoaded = useSelector(rightSuggestedChangesWasLoadedSelector)
  const partnerbrainHistoryWasLoaded = useSelector(partnerbrainHistoryWasLoadedSelector)

  const { id: rightId } = right

  const isFormLoading = !rightSuggestedChangeWasLoaded || !partnerbrainHistoryWasLoaded

  const { isFormOpen } = useManageDrawer({ formName: PARTNERBRAIN_OPTIMISATIONS })

  useEffect(() => {
    if (isFormOpen && rightId && !rightSuggestedChangeWasLoaded) {
      dispatch(getRightSuggestedChanges(rightId))
      dispatch(getPartnerbrainHistory({ right: rightId, limit: 5 }))
    }
  }, [dispatch, rightId, isFormOpen, rightSuggestedChangeWasLoaded])

  useEffect(
    () => () => {
      dispatch(clearRightSuggestedChanges())
      dispatch(clearPartnerbrainHistory())
    },
    [dispatch]
  )

  return (
    <FormDrawerWrapper
      formName={PARTNERBRAIN_OPTIMISATIONS}
      title="Partnerbrain Optimisations"
      showOpenButton={false}
      isFormLoading={isFormLoading}
      skeletonSectionsNumber={2}
    >
      <PartnerbrainOptimisationsForm rightId={rightId} />
    </FormDrawerWrapper>
  )
}

export default PartnerbrainOptimisations
